/**
 * Etiqueta de origen/categoría del vino (DO, zona, etc.)
 */
export function getWineCategoryLabel(item) {
  if (!item) return '';
  return item.categoryName || item.denomination || item.category?.name || '';
}

/**
 * Subtítulo para carrito/checkout: "Rioja - Tinto"
 */
export function formatWineSubtitle(item) {
  const category = getWineCategoryLabel(item);
  const type = item?.type || '';

  if (category && type) return `${category} - ${type}`;
  return category || type || '';
}
